import { DEC_LOADING, INC_LOADING, SET_ERROR_MESSAGE, SET_WAITING_PROMISE } from './mutation-types'
import { UPDATE_TIME } from './action-types'
import * as Sentry from "@sentry/browser"

/* Flatten a DRF error body ({detail}, [msg], {field: [msg]}, nested) into readable text */
export function formatApiErrorData (data, prefix = '') {
  if (data === null || data === undefined || data === '') {
    return ''
  }
  if (typeof data === 'string') {
    // HTML error pages (e.g. proxy errors) are not useful to show
    if (data.trimStart().startsWith('<')) {
      return ''
    }
    return prefix ? `${prefix}: ${data}` : data
  }
  if (Array.isArray(data)) {
    return data.map(item => formatApiErrorData(item, prefix)).filter(Boolean).join('; ')
  }
  if (typeof data === 'object') {
    return Object.entries(data).map(([key, value]) => {
      const label = ['detail', 'non_field_errors'].includes(key) ? prefix : (prefix ? `${prefix}.${key}` : key)
      return formatApiErrorData(value, label)
    }).filter(Boolean).join('; ')
  }
  return prefix ? `${prefix}: ${data}` : String(data)
}

export async function loadingStateWrapper (context, successCase, errorCase = null) {
  context.commit(INC_LOADING, null, { root: true })
  try {
    return await successCase()
  } catch (error) {
    const responseData = error?.response?.data
    const detail = formatApiErrorData(responseData)
    if (error?.response?.status !== 401) {
      const message = detail
        ? `Fehler in der Übertragung (${error.response.status}): ${detail}`
        : `Fehler in der Übertragung: ${error}`
      await context.commit(SET_ERROR_MESSAGE, { message }, { root: true })
    }
    Sentry.captureException(error, responseData !== undefined ? { extra: { responseData } } : undefined)
    if (errorCase) {
      await errorCase(error)
    }
  } finally {
    await context.commit(DEC_LOADING, null, { root: true })
    await context.dispatch(UPDATE_TIME, null, { root: true })
  }
}

export async function cachedActionWrapper (context, key, successCase, errorCase = null) {
  /* See if we're already doing the process requested */
  const cachedPromise = context.rootState.waitingPromises[key]
  if (cachedPromise) {
    return cachedPromise
  }

  /* Create the promise and store it in the root state */
  const promise = loadingStateWrapper(context, successCase, errorCase)
  context.commit(SET_WAITING_PROMISE, { key, promise }, { root: true })
  return promise
}
